import type { ReactNode } from 'react';
import { Icon } from './Icon.js';

export interface EmptyStateProps {
  readonly label?: string;
  readonly hint?: ReactNode;
  readonly icon?: ReactNode;
  readonly action?: ReactNode;
  readonly testId?: string;
}

export function EmptyState({
  label = 'Gösterilecek bir şey yok.',
  hint,
  icon,
  action,
  testId,
}: EmptyStateProps): JSX.Element {
  return (
    <div className="empty-state" data-testid={testId}>
      <div className="empty-icon">{icon ?? <Icon.Inbox size={22} />}</div>
      <div className="empty-title">{label}</div>
      {hint ? <div className="empty-desc">{hint}</div> : null}
      {action}
    </div>
  );
}
